import { rankingStories } from "@/mocks/chiguaData";
import { formatViews } from "@/utils/format";
import SectionHeading from "./SectionHeading";

const medal: Record<number, { icon: string; cls: string; text: string }> = {
  1: { icon: "ri-medal-2-fill", cls: "bg-accent-500 text-background-50", text: "离谱榜首" },
  2: { icon: "ri-medal-2-fill", cls: "bg-secondary-400 text-background-50", text: "意外亚军" },
  3: { icon: "ri-medal-2-fill", cls: "bg-secondary-300 text-foreground-800", text: "反转季军" },
};

export default function Ranking() {
  return (
    <section id="ranking" className="bg-background-100/60 py-14 md:py-20">
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        <SectionHeading
          kicker="本周离谱现场"
          title="结局意外盘点 TOP 榜"
          desc="被网友票选出来的「最意想不到」神展开，越往后越离谱，建议做好心理准备再看。"
        />

        <div className="mt-10 grid gap-4 lg:grid-cols-3">
          {rankingStories.map((s, i) => {
            const m = medal[i + 1];
            return (
              <article
                key={s.id}
                className={`flex flex-col rounded-3xl p-6 ${
                  i === 0 ? "border border-accent-200 bg-accent-100/50" : "border border-background-200 bg-background-50"
                }`}
              >
                <div className="flex items-center justify-between">
                  <span className={`inline-flex items-center gap-1.5 rounded-full px-3 py-1 text-xs font-bold ${m.cls}`}>
                    <i className={m.icon} aria-hidden="true"></i>
                    TOP {i + 1} · {m.text}
                  </span>
                  <span className="text-4xl font-black text-secondary-300">0{i + 1}</span>
                </div>

                <h3 className="mt-4 font-heading text-lg font-bold leading-snug text-foreground-950">
                  {s.title}
                </h3>
                <p className="mt-3 line-clamp-3 text-sm leading-relaxed text-foreground-600">{s.hook}</p>

                <div className="mt-5 rounded-xl bg-background-50/80 p-3.5">
                  <p className="flex items-center gap-1 text-xs font-semibold text-primary-600">
                    <i className="ri-flashlight-fill" aria-hidden="true"></i>
                    反转结局
                  </p>
                  <p className="mt-1.5 line-clamp-2 text-xs leading-relaxed text-foreground-700">{s.twist}</p>
                </div>

                <div className="mt-4 flex items-center gap-3 border-t border-background-200 pt-4 text-xs text-foreground-500">
                  <span className="inline-flex items-center gap-1">
                    <i className="ri-user-smile-line" aria-hidden="true"></i>
                    {s.author}
                  </span>
                  <span className="inline-flex items-center gap-1">
                    <i className="ri-eye-line" aria-hidden="true"></i>
                    {formatViews(s.views)} 围观
                  </span>
                  <span className="ml-auto inline-flex items-center gap-1 text-primary-600">
                    <i className="ri-heart-3-fill" aria-hidden="true"></i>
                    {formatViews(s.likes)}
                  </span>
                </div>
              </article>
            );
          })}
        </div>
      </div>
    </section>
  );
}